import { createFileRoute } from '@tanstack/react-router';
import { billingSearch } from '../screens/company/billing-search';
import { PlanTopic } from '../screens/company/topics/PlanTopic';

export const Route = createFileRoute('/t/$tenant/settings/billing/plan')({
  validateSearch: billingSearch,
  component: RouteComponent,
});

function RouteComponent() {
  const { checkout, pack } = Route.useSearch();
  return <PlanTopic checkout={checkout ?? null} pack={pack ?? null} />;
}
